<template>
  <b-card>
    <b-row v-if="!!coach_file">
      <b-col class="col-12 col-md-6">
        <address>
          <div><strong>{{ coach_file.name }}</strong></div>
          <div v-if="!!coach_file.email">{{ coach_file.email }}</div>
          <div v-if="!!coach_file.mobile">{{ coach_file.mobile }}</div>
          <div v-for="(info, index) in coach_file.infos" :key="'info'+index">
            <small class="text-muted">{{ info.label }}:</small>
            <span>{{ info.text }}</span>
          </div>
          <div>
            <small :class="isExpired ? 'text-danger' : 'text-muted'">{{ trans('expiration') }} - {{ trans('first_aid') }}:</small>
            <span :class="isExpired ? 'text-danger' : ''">{{ !!expiredAt ? moment(expiredAt).format('LL') : 'N/A' }}</span>
          </div>
          <div v-if="coach_file.header_placeholders" v-html="coach_file.header_placeholders"></div>
        </address>
      </b-col>
      <b-col class="col-auto col-md-6 text-right">
        <b-button variant="link" class="text-branded" :disabled="busy" @click="fetch">
          <i v-if="!busy" class="fa fa-fw fa-redo"></i>
          <i v-if="busy" class="fa fa-fw fa-circle-notch fa-spin"></i>
        </b-button>
      </b-col>
    </b-row>

    <b-table
      id="filled_forms"
      ref="table"
      class="bg-white"
      responsive
      show-empty
      :fields="fields"
      :items="recipientForms"
    >
      <template #empty>
        <p align="center">
          <span v-if="!busy && !error">{{ trans('none') }}</span>
          <span v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin"></i>
            {{ trans('please_wait') }}
          </span>
        </p>
      </template>
      <template #cell(name)="data">
        <b-button variant="link" class="p-0 text-branded text-left" :disabled="busy" @click="onClickForm(data.item)">
          <small>
            <i class="fa fa-fw fa-file-alt"></i>
          </small>
          <span>{{ data.value }}</span>
        </b-button>
      </template>
      <template #cell(status)="data">
        <div v-if="!!data.value && data.value.toLowerCase().indexOf('cert') === -1" class="text-danger">
          <i class="fa fa-fw fa-user-clock"></i>
          {{ data.value }}
        </div>
        <div v-if="!!data.value && data.value.toLowerCase().indexOf('cert') >= 0" class="text-success">
          <i class="fa fa-fw fa-user-graduate"></i>
          {{ data.value }}
        </div>
      </template>
    </b-table>


    <client-form-iframe-modal
      :organization="organization"
      :upid="recipient_form_upid"
      :urid="recipient_urid"
      :title="trans(!!recipient_urid ? 'modify' : 'new')"
      @hidden="fetch"
    ></client-form-iframe-modal>
  </b-card>
</template>

<script>
  import ClientFormIframeModal from './ClientFormIframeModal'

  export default {
    props: {
      organization: Object,
      client: Object,
      clientTab: Object,
    },
    components: {
      ClientFormIframeModal,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        coach_file: null,
        recipient_form_upid: null,
        recipient_urid: null,
      }
    },
    computed: {
      recipientForms() {
        if (!this.coach_file) return []
        return this.coach_file.forms
      },
      fields() {
        let fields = [
          {
            key: 'name',
            label: trans('form'),
          },
          {
            key: 'status',
            label: trans('status'),
          },
          // removed date on clients demand
          /* {
            key: 'updated_at',
            label: trans('date'),
            formatter(value) {
              return !!value ? moment(value).format('LL') : null
            },
          }, */
        ]
        return fields
      },
      expiredAt() {
        if (!this.coach_file) return null
        return this.coach_file.expired_at
      },
      isExpired() {
        if (!this.expiredAt) return false
        return moment(this.expiredAt).isBefore(moment().startOf('day'))
      },
    },
    methods: {
      onClickForm(recipient_form) {
        this.recipient_form_upid = recipient_form.upid
        this.recipient_urid = !!recipient_form.recipient ? recipient_form.recipient.urid : null
        this.$bvModal.show('client-form-iframe-modal')
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/fcq_coach_file`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.coach_file = response.data
          this.recipient_form_upid = null
          this.recipient_urid = null
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
    mounted() {
      window.customTabFcqCoach = this
      this.fetch()
    },
  }
</script>